import { get, forEach, compact } from 'lodash-es';

export const subscriptionList = ({ values }) => {
  const list = [];
  const subscriptions = compact(get(values, 'subscriptions', []));
  // each covered element should have a subscription element
  const coveredList = get(values, 'covered', []);
  forEach(coveredList, (covered, index) =>
    list.push({
      covered,
      subscriber: {
        billing_mode: get(subscriptions, `[${index}.billing_mode]`),
        direct_debit: get(subscriptions, `[${index}.direct_debit]`),
        allowed_direct_debit_day: get(subscriptions, `[${index}.allowed_direct_debit_day]`),
        phone: get(subscriptions, `[${index}.phone]`),
        email: get(subscriptions, `[${index}.email]`),
        addresses: get(subscriptions, `[${index}.addresses]`),
        subscriber: get(subscriptions, `[${index}.subscriber]`),
        covered: index,
      },
    })
  );
  return list;
};
